import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Eye, ArrowUpRight } from 'lucide-react';
import PrivateBookingBadge from '../../shared/PrivateBookingBadge';
import { isPrivateBooking, PRIVATE_PAYOUT_EXCLUDED_NOTE } from '../../../utils/bookingSource';

const RecentPayments = ({ payments = [] }) => {
  const navigate = useNavigate();

  // Helper function to format currency
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '$0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '$0.00';
    return `$${numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'failed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Recent Payments</h2>
        <button
          onClick={() => navigate('/admin/payments')}
          className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1"
        >
          View All
          <ArrowUpRight className="w-4 h-4" />
        </button>
      </div>
      {payments.length > 0 ? (
        <div className="space-y-3">
          {payments.slice(0, 5).map((payment) => {
            const isPrivate = isPrivateBooking(payment);
            return (
            <div
              key={payment.id}
              onClick={() => navigate(`/admin/payments/${payment.id}`)}
              className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <p className="font-medium text-gray-900">
                    {formatCurrency(payment.amount || 0)}
                  </p>
                  {isPrivate && <PrivateBookingBadge />}
                  <span className={`px-2 py-1 rounded text-xs font-medium ${getStatusColor(payment.status)}`}>
                    {payment.status}
                  </span>
                </div>
                <p className="text-xs text-gray-500">
                  {payment.booking?.booking_reference || 'Payment'} • {formatDate(payment.created_at)}
                </p>
                {isPrivate && (
                  <p className="text-xs text-indigo-600 mt-0.5">{PRIVATE_PAYOUT_EXCLUDED_NOTE}</p>
                )}
              </div>
              <Eye className="w-5 h-5 text-gray-400 flex-shrink-0" />
            </div>
          );
          })}
        </div>
      ) : (
        <div className="text-center py-8">
          <CreditCard className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">No recent payments</p>
        </div>
      )}
    </div>
  );
};

export default RecentPayments;

